import { apiConfig } from 'config';
import { swManagerRequest } from './utils';

export const deleteBeamTable = (id) => {
  const url = apiConfig.swManagerDeleteBeamTable(id);
  const options = { method: 'DELETE' };

  return swManagerRequest(url, options);
};
